"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullRaceVideoFilesInterface = void 0;
class FullRaceVideoFilesInterface {}
exports.FullRaceVideoFilesInterface = FullRaceVideoFilesInterface;